<!-- USE ONLY for customizing rich-text via '@portabletext/svelte' -->
<script lang="ts">
	import type { BlockComponentProps } from '@portabletext/svelte';
	import type { HTMLAttributes } from 'svelte/elements';

	interface Props extends HTMLAttributes<HTMLElement> {
		portableText: BlockComponentProps;
	}

	let { children, portableText }: Props = $props();

	let listItem = $derived(portableText?.value.listItem);
	let level = $derived(portableText?.value.level);
</script>

{#if listItem === 'bullet'}
	<ul class="ml-6">{@render children?.()}</ul>
{:else if listItem === 'number' && level && level > 1}
	<ol class="ml-6 list-[lower-alpha]">{@render children?.()}</ol>
{:else}
	<ol class="ml-6 list-decimal">{@render children?.()}</ol>
{/if}
